// 用户等级信息
export const USER_LEVEL_INFO = [
  {
    level: 0,
    title: '',
  },
  {
    level: 1,
    title: '共享萌新',
  },
  {
    level: 2,
    title: '共享新秀',
  },
  {
    level: 3,
    title: '共享达人',
  },
  {
    level: 4,
    title: '共享奇兵',
  },
  {
    level: 5,
    title: '共享精锐',
  },
  {
    level: 6,
    title: '共享卫士',
  },
  {
    level: 7,
    title: '共享先锋',
  },
  {
    level: 8,
    title: '共享大师',
  },
  {
    level: 9,
    title: '共享统帅',
  },
  {
    level: 10,
    title: '共享王者',
  },
];

// 用户等级信息配置
export const USER_LEVEL_CONFIG = {
  '-1': {
    medal: '',
    titleColor: 'FF000000', // 标题字体颜色
    darkBrightness: 1, // 状态栏字体颜色，0-浅色，1-深色
    backgroundColor: 'FFFFFFFF', // 导航栏背景颜色
  },
  0: {
    medal: '共享实践者',
    titleColor: 'FF000000', // 标题字体颜色
    darkBrightness: 1, // 状态栏字体颜色，0-浅色，1-深色
    backgroundColor: 'FFC6D2D9', // 导航栏背景颜色
  },
  1: {
    medal: '共享实践者',
    titleColor: 'FF000000',
    darkBrightness: 1,
    backgroundColor: 'FFB3C4D3',
  },
  2: {
    medal: '共享探索者',
    titleColor: 'FF000000',
    darkBrightness: 1,
    backgroundColor: 'FFFFDBB9',
  },
  3: {
    medal: '共享挖掘者',
    titleColor: 'FF000000',
    darkBrightness: 1,
    backgroundColor: 'FFF5CF6C',
  },
  4: {
    medal: '共享守望者',
    titleColor: 'FFFFFFFF',
    darkBrightness: 0,
    backgroundColor: 'FFE37138',
  },
  5: {
    medal: '共享领航者',
    titleColor: 'FFFFFFFF',
    darkBrightness: 0,
    backgroundColor: 'FF9F744E',
  },
  6: {
    medal: '资源大拿',
    titleColor: 'FFFFFFFF',
    darkBrightness: 0,
    backgroundColor: 'FF1B2B64',
  },
  7: {
    medal: '资源大咖',
    titleColor: 'FFFFFFFF',
    darkBrightness: 0,
    backgroundColor: 'FF0A1A3D',
  },
  8: {
    medal: '资源大佬',
    titleColor: 'FFFFFFFFF',
    darkBrightness: 0,
    backgroundColor: 'FF292830',
  },
  9: {
    medal: '资源巨头',
    titleColor: 'FFFFFFFF',
    darkBrightness: 0,
    backgroundColor: 'FF151414',
  },
  10: {
    medal: '资源大鳄',
    titleColor: 'FFFFFFFF',
    darkBrightness: 0,
    backgroundColor: 'FF040913',
  },
};

// 成就勋章类型
export const WELFARE_MEDAL_TYPE = 8;
// 提现减免
export const WELFARE_WITHDRAW_TYPE = 3;
// 云豆奖励
export const WELFARE_CLOUDBEAN_TYPE = 12;

// 月月享福利类型
export const WELFARE_MONTH_REWARD_TYPES = [4, 5, WELFARE_CLOUDBEAN_TYPE];
// 升级享享福利类型
export const WELFARE_UPDATE_REWARD_TYPES = [9, 10, 11];

// 福利信息配置
export const WELFARE_CONFIG_INFO = {
  '-1': {
    welfareListTitle: '--',
    welfarePrefix: '',
    welfareSuffix: '',
    welfareDesc: '--',
    useInstruction: '<p>--</p>',
    withTag: false,
    btnText: '',
  },
  0: {
    // 福利标题
    title: '专属商务1V1',
    // 福利简称
    // shortTitle: '商务1V1',
    // 权益描述，用于用户等级专属权益模块展示
    desc: '1V1优享，专人对接',
    // 是否展示标签
    withTag: false,
    // 按钮文案，为空则不显示按钮
    btnText: '',
    // 福利详情页相关配置
    // 福利详情列表标题，单独配置，需换行
    welfareListTitle: `专属\n商务1V1`,
    // 福利详情前缀，用于福利详情页拼接
    welfarePrefix: '',
    // 福利详情后缀，用于福利详情页拼接
    welfareSuffix: '商务1V1',
    // 福利描述，用于福利详情页展示
    welfareDesc: '1V1优享，专人对接',
    // 说明模块标题
    useTitle: '使用说明',
    // 使用说明
    useInstruction: `<p>1、商务1V1，指Lv9、Lv10用户可享受商务1V1专人对接服务，帮助解决包括但不限于上机、跑量、技术指导、异常排查等事项。</p>
    <p>2、在用户首次升至Lv9或Lv10后，专属商务会于2个工作日内，通过官方企微进行1V1对接。</p>
    <p>3、网心云可以根据实际情况对权益规则进行变动和调整，相关变动或调整将公布在权益页面上，并于公布后合法生效。</p>`,
  },
  1: {
    title: '售后专享服务',
    desc: '人工客服、售后工单，专享特权',
    withTag: true,
    btnText: '',
    welfareListTitle: `售后\n专享服务`,
    welfarePrefix: '',
    welfareSuffix: '',
    welfareDesc: '人工客服、售后工单，专享特权',
    useTitle: '使用说明',
    useInstruction: `<p>1、售后专享服务，指Lv1-Lv10用户在进入网心云人工客服时、提交售后工单时所享受到的售后服务。等级越高，可享受的服务等级越高。</p>
    <p>2、服务等级定义：<br/>① 白银VIP服务：智能客服全天24小时在线，支持上午9点-晚上19点的人工客服，售后工单快速处理。<br/>② 黄金VIP服务：智能客服全天24小时在线，支持上午9点-晚上19点的人工客服，售后工单高速处理。<br/>③ 钻石VIP服务：智能客服全天24小时在线，支持上午9点-晚上19点的人工客服，售后工单极速处理。</p>
    <p>3、用户所享受的服务等级，根据当前进入服务时所展示的用户等级来决定，如接入人工服务时以当时展示的等级为准，售后工单则以提报工单时展示的等级为准。</p>
    <p>4、网心云可以根据实际情况对权益规则进行变动和调整，相关变动或调整将公布在权益页面上，并于公布后合法生效。</p>`,
  },
  2: {
    title: '专属定向优质业务',
    desc: '专享稀缺、优质定向业务',
    withTag: false,
    btnText: '',
    welfareListTitle: `专属定向\n优质业务`,
    welfarePrefix: '',
    welfareSuffix: '可报名专属优质定向业务',
    welfareDesc: '专享稀缺、优质定向业务',
    useTitle: '使用说明',
    useInstruction: `<p>1、专属优质定向业务，指Lv7-Lv10用户可享受专属优质、稀缺定向业务的上机报名。等级越高，可报名的优质专属业务就越多。</p>
    <p>2、网心云可以根据实际情况对权益规则进行变动和调整，相关变动或调整将公布在权益页面上，并于公布后合法生效。</p>`,
  },
  3: {
    title: '提现服务费减免',
    desc: '每月第一个提现日服务费减免',
    withTag: false,
    btnText: '',
    welfareListTitle: `提现\n服务费减免`,
    welfarePrefix: '提现服务费减免',
    welfareSuffix: '',
    welfareDesc: '每月第一个提现日服务费减免',
    useTitle: '使用说明',
    useInstruction: `<p>1、提现服务费减免，指Lv5-Lv10中的个人用户在每月第一个提现日选择银行卡提现时，可享受在【7%+1元】服务费基础上进行指定比例的减免。等级越高，可减免比例越高。</p>
    <p>2、减免金额在每一笔提现产生的服务费基础上进行核算减免，每月第一个提现日内不限减免次数，均可享受减免。</p>
    <p>3、计算公式：减免金额=(提现金额×7%+1)×减免比例，举例：Lv9用户通过银行卡提现1000元，减免金额=(1000×7%+1)×5%=3.55元。</p>
    <p>4、网心云可以根据实际情况对权益规则进行变动和调整，相关变动或调整将公布在权益页面上，并于公布后合法生效。</p>`,
  },
  4: {
    title: '月月享-高阶加成卡',
    desc: '月月享-高阶加成卡',
    withTag: false,
    btnText: '',
    welfareListTitle: `月月享\n高阶加成卡`,
    welfarePrefix: '',
    welfareSuffix: '高阶加成卡',
    welfareDesc: '各类高阶加成卡，每月发放1次',
    useTitle: '使用说明',
    useInstruction: `<p>1、月月享-高阶加成卡，指Lv8-Lv10用户每月可免费获得高阶产品收益加成卡，每月仅发放一次。等级越高，加成卡价值越高。</p>
    <p>2、高阶加成卡通常可用于OES系列、x86等设备上，确切的使用范围请以加成卡上展示的设备类型为准。</p>
    <p>3、收益加成卡无需用户自主领取，每月1号自动发放到用户账户上，根据1号当天展示的用户等级对应的福利内容进行发放。具体查看方式为【网心云app首页-我的-权益】，有效期及具体使用规则以加成卡上展示的为准。</p>
    <p>4、网心云可以根据实际情况对权益规则进行变动和调整，相关变动或调整将公布在权益页面上，并于公布后合法生效。</p>`,
  },
  5: {
    title: '月月享-中阶加成卡',
    desc: '月月享-中阶加成卡',
    withTag: false,
    btnText: '',
    welfareListTitle: `月月享\n中阶加成卡`,
    welfarePrefix: '',
    welfareSuffix: '中阶加成卡',
    welfareDesc: '各类中阶加成卡，每月发放1次',
    useTitle: '使用说明',
    useInstruction: `<p>1、月月享-中阶加成卡，指Lv2-Lv10用户每月可免费获得中阶产品收益加成卡，每月仅发放一次。等级越高，加成卡价值越高。</p>
    <p>2、中阶加成卡通常可用于容器魔方、三方盒子、玩客云现金版、赚钱宝3代系列、OEA系列、OEC系列等设备上，确切的使用范围请以加成卡上展示的设备类型为准。</p>
    <p>3、收益加成卡无需用户自主领取，每月1号自动发放到用户账户上，根据1号当天展示的用户等级对应的福利内容进行发放。具体查看方式为【网心云app首页-我的-权益】，有效期及具体使用规则以加成卡上展示的为准。</p>
    <p>4、网心云可以根据实际情况对权益规则进行变动和调整，相关变动或调整将公布在权益页面上，并于公布后合法生效。</p>`,
  },
  6: {
    title: '新品优先体验',
    desc: '优先体验网心云新品',
    withTag: false,
    btnText: '',
    welfareListTitle: `新品\n优先体验`,
    welfarePrefix: '',
    welfareSuffix: '优先体验新产品、新高收益业务',
    welfareDesc: '快人一步，抢先体验新产品、新高收益业务',
    useTitle: '使用说明',
    useInstruction: `<p>1、新品优先体验，指Lv5-Lv10用户可优先体验官方不定期推出的新产品或者新高收益业务。等级越高，可优先体验的新产品或新高收益业务的类型越多。</p>
    <p>2、官方将通过网心云app的消息中心进行新品体验邀请。</p>
    <p>3、网心云可以根据实际情况对权益规则进行变动和调整，相关变动或调整将公布在权益页面上，并于公布后合法生效。</p>`,
  },
  7: {
    title: '生日福利',
    desc: '生日当天可以获得大礼包',
    withTag: false,
    btnText: '去领取',
    welfareListTitle: '生日福利',
    welfarePrefix: '',
    welfareSuffix: '生日当天可以获得大礼包',
    welfareDesc: '生日当天可以获得大礼包',
    useTitle: '使用说明',
    useInstruction: `<p>1、新品优先体验，指Lv5-Lv10用户可优先体验官方不定期推出的新产品或者新高收益业务。等级越高，可优先体验的新产品或新高收益业务的类型越多。</p>
    <p>2、官方将通过网心云app的消息中心进行新品体验邀请。</p>
    <p>3、网心云可以根据实际情况对权益规则进行变动和调整，相关变动或调整将公布在权益页面上，并于公布后合法生效。</p>`,
  },
  8: {
    title: '永久成就勋章',
    desc: '专属成就勋章，终生拥有',
    withTag: true,
    btnText: '查看所有勋章',
    welfareListTitle: `永久\n成就勋章`,
    welfarePrefix: '',
    welfareSuffix: '',
    welfareDesc: '每进阶一个等级，即可获得相应勋章，永久展示，实力彰显',
    useTitle: '勋章说明',
    useInstruction: `<p>1、每进阶到一个等级，即可获得对应的勋章，勋章永久有效，并长期展示在勋章墙上；</p>
    <p>2、网心云可以根据实际情况对权益规则进行变动和调整，相关变动或调整将公布在权益页面上，并于公布后合法生效。</p>`,
  },
  9: {
    title: '升级享-高阶加成卡',
    desc: '升级享-高阶加成卡',
    withTag: false,
    btnText: '',
    welfareListTitle: `升级享\n高阶加成卡`,
    welfarePrefix: '',
    welfareSuffix: '高阶加成卡',
    welfareDesc: '各类高阶加成卡，一次发放',
    useTitle: '使用说明',
    useInstruction: `<p>1、升级享-高阶加成卡，指用户升级到对应等级后Lv6-Lv10即可免费获得的高阶产品收益加成卡，每个等级的加成卡及优惠券终生只发放一次。等级越高，加成卡价值越高。</p>
    <p>2、高阶加成卡通常可用于OES系列、x86等设备上，确切的使用范围请以加成卡上展示的设备类型为准。</p>
    <p>3、收益加成卡无需用户自主领取，首次升级到对应等级后即于当日发放，具体查看方式为【网心云app首页-我的-权益】，有效期及具体使用规则以加成卡上展示的为准。</p>
    <p>4、网心云可以根据实际情况对权益规则进行变动和调整，相关变动或调整将公布在权益页面上，并于公布后合法生效。</p>
    `,
  },
  10: {
    title: '升级享-中阶加成卡',
    desc: '升级享-中阶加成卡',
    withTag: false,
    btnText: '',
    welfareListTitle: `升级享\n中阶加成卡`,
    welfarePrefix: '',
    welfareSuffix: '中阶加成卡',
    welfareDesc: '各类中阶加成卡，一次发放',
    useTitle: '使用说明',
    useInstruction: `<p>1、升级享-中阶加成卡，指用户升级到对应等级后Lv1-Lv10即可免费获得的中阶产品收益加成卡，每个等级的加成卡及优惠券终生只发放一次。等级越高，加成卡价值越高。</p>
    <p>2、中阶加成卡通常可用于容器魔方、三方盒子、玩客云现金版、赚钱宝3代系列、OEA系列、OEC系列等设备上，确切的使用范围请以加成卡上展示的设备类型为准。</p>
    <p>3、收益加成卡无需用户自主领取，首次升级到对应等级后即于当日发放，具体查看方式为【网心云app首页-我的-权益】，有效期及具体使用规则以加成卡上展示的为准。</p>
    <p>4、网心云可以根据实际情况对权益规则进行变动和调整，相关变动或调整将公布在权益页面上，并于公布后合法生效。</p>
    `,
  },
  11: {
    title: '升级享-抵扣券',
    desc: '升级享-抵扣券',
    withTag: '',
    btnText: '',
    welfareListTitle: `升级享\n抵扣券`,
    welfarePrefix: '',
    welfareSuffix: '抵扣券包',
    welfareDesc: '各类抵扣券，一次发放',
    useTitle: '使用说明',
    useInstruction: `<p>1、升级享-抵扣券，指用户升级到对应等级后Lv1-Lv10即可免费获得的官方硬件抵扣券礼包，每个等级的抵扣券终生只发放一次。等级越高，券包越丰富，价值越高。</p>
    <p>2、抵扣券无需用户自主领取，首次升级到对应等级后即于当日发放，具体查看方式为【网心云app首页-我的-优惠券】，有效期及具体使用规则以抵扣券上展示的为准。</p>
    <p>3、网心云可以根据实际情况对权益规则进行变动和调整，相关变动或调整将公布在权益页面上，并于公布后合法生效。</p>
    `,
  },
  12: {
    title: '收益加成云豆',
    desc: '每日可享受基于贡献收益的云豆加成',
    withTag: '',
    btnText: '',
    welfareListTitle: `收益\n加成云豆`,
    welfarePrefix: '贡献收益加成',
    welfareSuffix: '',
    welfareDesc: '每日可享受贡献收益加成，通过云豆发放',
    useTitle: '权益说明',
    useInstruction: `<p>1、收益加成云豆，指Lv2-Lv10的用户可享受基于每日名下所有设备贡献收益一定比例的收益加成，加成奖励会以云豆发放，等级越高，可享受的加成比例越高。</p>
    <p>2、云豆无须领取，每日会和贡献收益自动发到用户的账户上，云豆可兑换包括但不限现金、加成卡、优惠券等。</p>
    <p>3、网心云可以根据实际情况对权益规则进行变动和调整，相关变动或调整将公布在权益页面上，并于公布后合法生效。</p>
    `,
  },
};

export const WELFARE_DESC = {
  reward: {
    title: '奖励说明',
    content: `月月享奖励：升级到该等级后，每月1号可收到对应奖励。\n升级享奖励：首次升级到该等级的当天，可收到对应奖励。`,
  },
  rights: {
    title: '特权说明',
    content: `达到对应的等级即可享受专属特权，\n等级越高，特权越多哦！`,
  },
};
